import React from 'react'
import Logo from '../../components/Logo'
import GympassLogo from './assets/wellhub_logo.svg?svgr-webpack'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { selectIsLoggedIn } from '../../store/userSlice'
import { useSelector } from 'react-redux'

export default function GympassHeader() {
  const isLoggedIn = useSelector(selectIsLoggedIn)

  return (
    <div className="relative py-20 md:py-32 md:text-center">
      <div className="text-left lg:text-center">
        <Link to="/">
          <Logo />
        </Link>
      </div>
      <div className="absolute right-0 top-1/2 flex -translate-y-1/2 transform">
        {isLoggedIn && (
          <Link
            to="/account"
            className="my-auto mr-12 text-Type type-14 md:mr-20 md:type-14-caps xl:type-14-demibold-caps"
          >
            <FormattedMessage
              id="Header.menuBar.account"
              defaultMessage="Account"
            />
          </Link>
        )}
        <div className="border-l-1 border-Border py-2 pl-12 md:rounded-6 md:border-1 md:px-16 md:py-6 md:text-center xl:rounded-8 xl:border-2 xl:px-20">
          <GympassLogo className="w-64 md:w-72 xl:w-auto" />
          <p className="-mt-8 text-grey-lighter type-14 md:-mt-6 md:type-14-caps xl:-mt-4 xl:type-14-demibold-caps">
            <FormattedMessage
              id="gympass_premium_access"
              defaultMessage="Premium access"
            />
          </p>
        </div>
      </div>
    </div>
  )
}
